<template>
    <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="290px"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                    v-model="date"
                    :label="label"
                    prepend-icon="event"
                    readonly
                    v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker v-model="date" no-title scrollable>
            <div class="flex-grow-1"></div>
            <v-btn text color="primary" @click="menu = false">Закрыть</v-btn>
            <v-btn text color="primary" @click="save">OK</v-btn>
        </v-date-picker>
    </v-menu>
</template>

<script>
    export default {
        name: "CommercialPolicyDatePicker",
        props:['idx', 'label', 'dateKey', 'initial'],
        data() {
            return {
                date: null,
                menu: false
            }
        },
        methods: {
            save() {
                this.$refs.menu.save(this.date);
                this.$emit('change', {date: this.date, key: this.dateKey, idx: this.idx})
            }
        },
        created() {
            this.date = this.initial;
        },
        watch: {
            initial() {
                this.date = this.initial;
            }
        }
    }
</script>

<style scoped>

</style>